const filtersLocale = {
  filter: "Filtrar",
  header: "Filtros",
  addFilter: "Agregar filtro",
  addFilterGroup: "Agregar grupo de filtros",
  simpleFilters: "Filtros simples",
  advanceFilters: "Filtros avanzados",
  today: "Hoy",
  day: "día",
  days: "días",
  inputPlaceholder: "Elige una opción",
  filterGroup: "Grupo de filtros",
  simpleFilter: {
    condition: "Mostrar resultados que cumplan con",
    allConditions: {
      title: "Todas las condiciones",
      description: "Los resultados coincidirán con todos los filtros",
    },
    anyCondition: {
      title: "Cualquier condición",
      description: "Los resultados coincidirán con al menos un filtro",
    },
  },
  advanceFilter: {
    condition: "Hacer coincidir",
    allConditions: {
      title: "Todos los grupos de filtros",
      description:
        "Se mostrarán resultados que cumplan con todos los grupos de filtros",
    },
    anyCondition: {
      title: "Cualquier grupo de filtros",
      description:
        "Se mostrarán resultados que cumplan con al menos un grupo de filtros",
    },
  },
  operations: {
    list: {
      eq: "Es igual a",
      not_eq: "No es igual a",
      null: "Está vacío",
      not_null: "No está vacío",
    },
    tagsList: {
      eq: "Es igual a",
      not_eq: "No es igual a",
      null: "Está vacío",
      not_null: "No está vacío",
    },
    string: {
      eq: "Es",
      not_eq: "No es",
      cont: "Contiene",
      not_cont: "No contiene",
      start: "Comienza con",
      end: "Termina con",
      null: "Está vacío",
      not_null: "No está vacío",
    },
    number: {
      eq: "Es igual a",
      not_eq: "No es igual a",
      gt: "Es mayor que",
      lt: "Es menor que",
      gteq: "Es mayor o igual a",
      lteq: "Es menor o igual a",
      null: "Está vacío",
      not_null: "No está vacío",
    },
    date: {
      eq: "Es",
      eq_days: "Ocurrió hace",
      lt: "Es antes de",
      gt: "Es después de",
      lteq: "Ocurrió hace más de",
      gteq: "Ocurrió hace menos de",
      null: "Está vacío",
      not_null: "No está vacío",
    },
    boolean: {
      true: "Es verdadero",
      false: "Es falso",
    },
  },
  groupConditions: {
    and: "Y",
    or: "O",
  },
};

const areaslocale = {
  label: "Área",
  header: "Selector de áreas",
  search: "Buscar",
  dependsOn: "Depende de",
  allTheCompany: "Todas las áreas",
  notAvailable: "Áreas no disponibles",
  buttons: {
    accept: "Seleccionar",
    cancel: "Cancelar",
  },
};

const activeFiltersViewLocale = {
  filterGroup: "Grupo de filtros",
  day: "día",
  days: "días",
  operations: {
    list: {
      eq: "Es igual a",
      not_eq: "No es igual a",
      null: "Está vacío",
      not_null: "No está vacío",
    },
    tagsList: {
      eq: "Es igual a",
      not_eq: "No es igual a",
      null: "Está vacío",
      not_null: "No está vacío",
    },
    string: {
      eq: "Es",
      not_eq: "No es",
      cont: "Contiene",
      not_cont: "No contiene",
      start: "Comienza con",
      end: "Termina con",
      null: "Está vacío",
      not_null: "No está vacío",
    },
    number: {
      eq: "Es igual a",
      not_eq: "No es igual a",
      gt: "Es mayor que",
      lt: "Es menor que",
      gteq: "Es mayor o igual a",
      lteq: "Es menor o igual a",
      null: "Está vacío",
      not_null: "No está vacío",
    },
    date: {
      eq: "Es",
      eq_days: "Ocurrió hace",
      lt: "Es antes de",
      gt: "Es después de",
      lteq: "Ocurrió hace más de",
      gteq: "Ocurrió hace menos de",
      null: "Está vacío",
      not_null: "No está vacío",
    },
    boolean: {
      true: "Es verdadero",
      false: "Es falso",
    },
  },
  activeFilterViewer: {
    simple: {
      title: "Filtros aplicados",
      clear: "Limpiar filtros",
    },
    advance: {
      clear: "Limpiar filtros",
    },
  },
};

const columnsFilter = ({
  authors = [],
  workflowConfigurations = [],
  closingReasons = [],
  requestOwners = [],
  searchFunctions = { fetchRequestOwners: () => {} },
}) => {
  return [
    {
      label: "Tipo",
      value: "search_type",
      type: "list",
      filterOptions: [
        {
          label: "Es igual a",
          value: "eq",
        },
        {
          label: "No es",
          value: "not_eq",
        },
      ],
      list: [
        {
          label: "Procesos Internos",
          value: "internal",
        },
        {
          label: "Procesos Externos",
          value: "external",
        },
        {
          label: "Procesos Mixtos",
          value: "mixed",
        },
      ],
    },
    {
      label: "Fecha",
      value: "created_at",
      type: "date",
      filterOptions: [
        {
          label: "Después del ",
          value: "gt",
        },
        {
          label: "Antes del ",
          value: "lt",
        },
      ],
    },
    {
      label: "Responsable",
      value: "responsible_full_name",
      type: "string",
      filterOptions: [
        {
          label: "Contiene",
          value: "cont_all",
        },
        {
          label: "No contiene",
          value: "not_cont",
        },
        {
          label: "Comienza con",
          value: "start",
        },
        {
          label: "Termina con",
          value: "end",
        },
        {
          label: "Sin responsable",
          value: "null",
        },
      ],
    },
    {
      label: "Prioridad",
      value: "search_priority",
      type: "list",
      filterOptions: [
        {
          label: "Es igual a",
          value: "eq",
        },
        {
          label: "No es",
          value: "not_eq",
        },
      ],
      list: [
        {
          label: "Alta",
          value: "high",
        },
        {
          label: "Media",
          value: "medium",
        },
        {
          label: "Baja",
          value: "low",
        },
      ],
    },
    {
      label: "Motivo de cierre",
      value: "closing_reason_id",
      type: "list",
      filterOptions: [
        {
          label: "Es igual a",
          value: "eq",
        },
        {
          label: "No es",
          value: "not_eq",
        },
      ],
      list: closingReasons,
    },
    {
      label: "Creador del proceso",
      value: "user_id",
      type: "list",
      filterOptions: [
        {
          label: "Es igual a",
          value: "eq",
        },
        {
          label: "No es",
          value: "not_eq",
        },
      ],
      list: authors,
    },
    {
      label: "Creador de solicitudes",
      value: "request_user_token",
      type: "list",
      filterOptions: [
        {
          label: "Es igual a",
          value: "eq",
        },
        {
          label: "No es",
          value: "not_eq",
        }
      ],
      list: requestOwners,
      async: {
        fn: (text, params) => {
          const term = typeof text === "string" && text.length > 0
            ? text
            : (params && (params.search || params.text || params.value)) || "";
          return searchFunctions.fetchRequestOwners(1, term);
        }
      },
    },
    {
      label: "Candidatos en mi etapa",
      value: "have_applicants",
      type: "boolean",
      filterOptions: [
        {
          label: "Si",
          value: "true",
        },
        {
          label: "No",
          value: "false",
        },
      ],
    },
    {
      filterOptions: [
        { label: "con candidatos en", value: "true" },
        { label: "sin candidatos en", value: "false" },
      ],
      label: "Candidatos en etapa",
      value: "have_list_applicants",
      type: "string",
    },
    {
      label: "Solicitud",
      value: "name_workflow",
      type: "string",
      filterOptions: [
        {
          label: "Contiene",
          value: "cont_all",
        },
        {
          label: "No contiene",
          value: "not_cont",
        },
        {
          label: "Es",
          value: "eq",
        },
        {
          label: "No es",
          value: "not_eq",
        },
        {
          label: "Está vacío",
          value: "null",
        },
        {
          label: "No está vacío",
          value: "not_null",
        },
      ],
    },
    {
      label: "Tipo de solicitud",
      value: "workflow_configuration_id",
      type: "list",
      filterOptions: [
        {
          label: "Es igual a",
          value: "eq",
        },
        {
          label: "No es",
          value: "not_eq",
        },
      ],
      list: workflowConfigurations,
    },
  ];
};

const columnsFilterPustulations = () => {
  return [
    {
      label: "Tipo",
      value: "search_type",
      type: "list",
      filterOptions: [
        {
          label: "Es igual a",
          value: "eq",
        },
        {
          label: "No es",
          value: "not_eq",
        },
      ],
      list: [
        {
          label: "Procesos Internos",
          value: "internal",
        },
        {
          label: "Procesos Externos",
          value: "external",
        },
        {
          label: "Procesos Mixtos",
          value: "mixed",
        },
      ],
    },
    {
      label: "Fecha",
      value: "applicants_uniq_applicant_created_at",
      type: "date",
      filterOptions: [
        {
          label: "Ocurrió hace menos de",
          value: "gteq",
        },
        {
          label: "Ocurrió hace más de",
          value: "lteq",
        },
      ],
    },
    {
      label: "Prioridad",
      value: "search_priority",
      type: "list",
      filterOptions: [
        {
          label: "Es igual a",
          value: "eq",
        },
        {
          label: "No es",
          value: "not_eq",
        },
      ],
      list: [
        {
          label: "Alta",
          value: "high",
        },
        {
          label: "Media",
          value: "medium",
        },
        {
          label: "Baja",
          value: "low",
        },
      ],
    },
  ];
};

const columnsFilterOffers = () => {
  return [
    {
      label: "Fecha",
      value: "applicants_uniq_applicant_created_at",
      type: "date",
      filterOptions: [
        {
          label: "Ocurrió hace menos de",
          value: "gteq",
        },
        {
          label: "Ocurrió hace más de",
          value: "lteq",
        },
      ],
    },
    {
      label: "Ubicación",
      value: "country_name",
      type: "string",
      filterOptions: [
        {
          label: "Contiene",
          value: "cont",
        },
        {
          label: "No contiene",
          value: "not_cont",
        },
        {
          label: "Es",
          value: "eq",
        },
        {
          label: "No es",
          value: "not_eq",
        },
        {
          label: "Comienza con",
          value: "start",
        },
        {
          label: "Termina con",
          value: "end",
        },
      ],
    },
    {
      label: "Jornada",
      value: "job_disponibility_description",
      type: "string",
      filterOptions: [
        {
          label: "Contiene",
          value: "cont",
        },
        {
          label: "No contiene",
          value: "not_cont",
        },
        {
          label: "Es",
          value: "eq",
        },
        {
          label: "No es",
          value: "not_eq",
        },
        {
          label: "Comienza con",
          value: "start",
        },
        {
          label: "Termina con",
          value: "end",
        },
      ],
    },
    {
      label: "Experiencia requerida",
      value: "experience_time",
      type: "number",
      filterOptions: [
        {
          label: "Es igual a",
          value: "eq",
        },
        {
          label: "No es",
          value: "not_eq",
        },
      ],
    },
  ];
};

export {
  filtersLocale,
  areaslocale,
  activeFiltersViewLocale,
  columnsFilter,
  columnsFilterPustulations,
  columnsFilterOffers,
};
